const AccountTitleEvent = {
  fetchAll: 'account-title/fetch-all',
  fetchOne: 'account-title/fetch-one',
  onClear: 'account-title/on-clear',
  onClearDetail: 'account-title/on-clear-detail',
  onEdit: 'account-title/on-edit'
}

export default AccountTitleEvent
